// helpers
import { resolveWpOriginUrl } from '@helpers/url'

interface SiteFooterHookReturn {
  resolveUrl: (url: string) => string
}

export const useSiteFooter = (): SiteFooterHookReturn => {
  const { public: { wpOriginUrl } } = useRuntimeConfig()

  const resolveUrl = (url: string): string => resolveWpOriginUrl(url, wpOriginUrl)

  return {
    resolveUrl,
  }
}
